import React from "react";
import ExcelDownloader from "../../common/ExcelDownloader/ExcelDownloader";
import { getSimpleFormattedDate } from "../../../utils/utils";

const combineChildrenHeaders = (children) => {
  return children.map((child) => {
    const { id, label, type } = child;
    return { key: id, label: label, type: type || "string" };
  });
};

const generateHeaders = (columns) => {
  return columns.flatMap((column) => {
    if (column?.children) {
      return combineChildrenHeaders(column.children);
    } else {
      const { id, label, type } = column;
      return { key: id, label: label, type: type || "string" };
    }
  });
};

const UserAndRoleExport = ({
  columns,
  datas,
  columnsForAdmins,
  datasForAdmins,
  columnsForApplicationAdministrator,
  datasForApplicationAdministrator,
  columnsForGlobalTechSupport,
  datasForGlobalTechSupport,
  columnsForUserAccessProvisioner,
  datasForUserAccessProvisioner,
  disabled = true,
} = {}) => {
  const headers = generateHeaders(columns);

  const tableData = datas.map((data) => {
    const row = {};
    headers.forEach((header) => {
      const { key } = header;
      row[key] = data[key];
    });
    return row;
  });

  const adminHeaders = generateHeaders(columnsForAdmins);

  const adminTableData = datasForAdmins?.map((data) => {
    const row = {};
    headers.forEach((header) => {
      const { key } = header;
      row[key] = data[key];
    });
    return row;
  });

  const applicationAdministratorHeaders = generateHeaders(
    columnsForApplicationAdministrator,
  );

  const applicationAdministratorTableData =
    datasForApplicationAdministrator?.map((data) => {
      const row = {};
      headers.forEach((header) => {
        const { key } = header;
        row[key] = data[key];
      });
      return row;
    });

  const globalTechSupportHeaders = generateHeaders(columnsForGlobalTechSupport);

  const globalTechSupportTableData = datasForGlobalTechSupport?.map((data) => {
    const row = {};
    headers.forEach((header) => {
      const { key } = header;
      row[key] = data[key];
    });
    return row;
  });

  const userAccessProvisionerHeaders = generateHeaders(
    columnsForUserAccessProvisioner,
  );

  const userAccessProvisionerTableData = datasForUserAccessProvisioner?.map(
    (data) => {
      const row = {};
      headers.forEach((header) => {
        const { key } = header;
        row[key] = data[key];
      });
      return row;
    },
  );

  return (
    <ExcelDownloader
      sheets={[
        {
          name: "Users_And_Roles",
          header: headers,
          data: tableData,
          showHeader: true,
        },
        {
          name: "Admin_Users",
          header: adminHeaders,
          data: adminTableData,
          showHeader: true,
        },
        {
          name: "Application_Administrator_Users",
          header: applicationAdministratorHeaders,
          data: applicationAdministratorTableData,
          showHeader: true,
        },
        {
          name: "Global_Tech_Support_Users",
          header: globalTechSupportHeaders,
          data: globalTechSupportTableData,
          showHeader: true,
        },
        {
          name: "User_Access_Provisioner_Users",
          header: userAccessProvisionerHeaders,
          data: userAccessProvisionerTableData,
          showHeader: true,
        },
      ]}
      disabled={disabled}
      fileName={`UsersAndRoles_${getSimpleFormattedDate()}.xlsx`}
    />
  );
};

export default UserAndRoleExport;
